module.exports = __webpack_public_path__ + "static/pie_painter_1-77ecba4f0706ad496fa1722595941b92.png";